import React, { useEffect, useState } from "react";
import api from "../api";

export default function AssignEmployees({ loadId }) {

  const [employees, setEmployees] = useState([]);
  const [selected, setSelected] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadEmployees = async () => {
    try {
      const r = await api.get('/employees-list');
      setEmployees(r.data);
    } catch (err) {
      alert('Failed to load employees');
    }
  };

  useEffect(() => {
    loadEmployees();
  }, []);

  const toggle = (id) => {
    setSelected(prev =>
      prev.includes(id)
        ? prev.filter(x => x !== id)
        : [...prev, id]
    );
  };

  const assign = async () => {
    if (!selected.length) {
      alert('Select at least one employee');
      return;
    }

    setLoading(true);

    try {
      const r = await api.post('/assignments', {
        load_id: loadId,
        employee_ids: selected
      });

      alert('Assigned successfully');
      setSelected([]);
      await loadEmployees();

    } catch (err) {
      alert('Assign failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mt-3 container-fluid px-2">

      <div className="card p-2">

        <h5 className="mb-2">
          👷 Assign Employees (Load #{loadId})
        </h5>

        {/* EMPLOYEE LIST */}
        <div className="list-group">

          {employees.map(emp => (
            <label
              key={emp.id}
              className={`list-group-item d-flex justify-content-between align-items-center ${selected.includes(emp.id) ? 'active text-white' : ''}`}
              style={{ cursor: "pointer" }}
            >

              <div>
                <div>
                  <input
                    type="checkbox"
                    checked={selected.includes(emp.id)}
                    onChange={() => toggle(emp.id)}
                    className="me-2"
                  />
                  {emp.user?.name || emp.name}
                </div>

                <small>
                  Hourly: {emp.hourly_rate || '—'}
                </small>
              </div>

              {selected.includes(emp.id) && (
                <span className="badge bg-light text-dark">Selected</span>
              )}

            </label>
          ))}

        </div>

        {/* spacing so button doesn't overlap */}
        <div style={{ height: "70px" }}></div>

      </div>

      {/* 🔥 Sticky Assign Button */}
      {/* 🔥 ACTION BUTTON (Responsive) */}

{/* Mobile: Sticky */}
<div className="d-md-none fixed-bottom bg-white p-2 border-top shadow">
  <button
    className="btn btn-success w-100"
    onClick={assign}
    disabled={loading}
  >
    {loading ? "Assigning..." : `Assign (${selected.length})`}
  </button>
</div>

{/* Desktop: Inline */}
<div className="d-none d-md-flex justify-content-center mt-3">
  <button
    className="btn btn-success px-4"
    onClick={assign}
    disabled={loading}
  >
    {loading ? "Assigning..." : `Assign (${selected.length})`}
  </button>
</div>

{/* Mobile spacing */}
<div className="d-md-none" style={{ height: "70px" }}></div>

    </div>
  );
}